import { IConfirmableInjectedAction } from '../../../../interfaces';
import { catchError } from 'rxjs/operators';
import { get } from 'lodash';
import { of } from 'rxjs';

export class InjectedTriggerMigrationChunkRollback implements IConfirmableInjectedAction {
  performActionAfterConfirm = (action, bindObj) => {
    const rollbackId = get(action, 'payload.formData.sourceTransactionUUIDChunk');

    if (!rollbackId) {
      bindObj.worklist.notificationMessageService.error('Please choose valid rollback id');
      return;
    }

    bindObj.worklist.dataMigrationService.triggerRollbackImport(rollbackId, true)
      .subscribe(
        () => {
          bindObj.worklist.notificationMessageService.info(`Rollback trigger for rollbackId:   ${rollbackId}  in-progress`);
        },
        catchError((err) => {
          console.error('Rollback trigger for rollbackId is failed : Error : ', err.message);
          bindObj.worklist.notificationMessageService.error(`Rollback trigger for rollbackId is failed:   ${rollbackId}`);
          return of(err);
        })
      );
  }
}
